@if (isVerifying) {
<div class="verification-screen">
  <div class="verification-content">
    <div class="spinner-container">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
        <circle class="spinner-dot" cx="25" cy="5" r="3" fill="#04a251"></circle>
      </svg>
    </div>
    <h2 class="verification-title">Verifying Authorization...</h2>
    <p class="verification-subtitle">SECURE ACCESS GATEWAY</p>
  </div>
</div>
}
@if (isError) {
<div class="verification-screen">
  <div class="verification-content">
    <div class="spinner-container">
      <svg viewBox="0 0 50 50" style="width:60px;height:60px;">
        <circle cx="25" cy="25" r="20" fill="none" stroke="#e53e3e" stroke-width="3" stroke-dasharray="90 150"></circle>
      </svg>
    </div>
    <h2 class="verification-title" style="color:#e53e3e;">Unable to Open Complaint</h2>
    <p class="verification-subtitle" style="text-transform:none;letter-spacing:0;font-size:13px;color:#555;line-height:1.7;">
      Something went wrong while loading this complaint.<br>
      You can <strong>refresh the page</strong> to try again,<br>
      or <strong>close this tab</strong> and reopen the complaint from the dashboard.
    </p>
    <button (click)="reload()" style="margin-top:20px;padding:10px 24px;background:#04a251;color:#fff;border:none;border-radius:8px;font-size:14px;cursor:pointer;">
      Refresh Page
    </button>
  </div>
</div>
}
@if (!isVerifying && !isError) {
<div class="vc-page">

  <!-- ─── Top Header Bar (not collapsible) ─── -->
  <div class="vc-topbar">
    <div class="vc-topbar-left">
      <div class="vc-title-block">
        <div class="vc-title-row">
          <span class="vc-title">{{ "VIEW_COMPLAINT" | translate }}</span>
        </div>
        <p class="vc-complaint-id">Complaint ID: {{ complaint?.complaintNo || "N/A" }}</p>
      </div>
    </div>
    <div class="vc-topbar-center">
      <span class="vc-status-badge" [ngClass]="getStatusClass(complaint?.currentProcess?.name)">
        {{ complaint?.currentProcess?.name || "N/A" | uppercase }}
      </span>
    </div>
    <div class="vc-topbar-right">
      <button class="vc-btn-pdf" (click)="downloadPdf()" type="button">
        <span class="material-icons">print</span> Print
      </button>
    </div>
  </div>

  <!-- ─── Card Group ─── -->
  <div class="vc-card-group">

    <!-- ─── Citizen Details ─── -->
    <div class="vc-card" *ngIf="canSeeInfo">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('citizen')">
        <span class="material-icons vc-header-icon">person</span>
        <span class="vc-header-title">{{ "CITIZEN_DETAILS" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['citizen']">expand_more</span>
      </div>
      <div class="vc-card-body" *ngIf="!collapsed['citizen']">
        <div class="vc-fields-grid">
          <div class="vc-field">
            <div class="vc-field-label">{{ "COMPLAINANT_NAME" | translate }}</div>
            <div class="vc-field-value">{{ ((complaint?.complainantTitle || '') + ' ' + (complaint?.complainantName || '')).trim() || 'N/A' }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "GENDER" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.gender || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "CNIC" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.cnic || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "PHONE" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.cellPhoneNo || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "EMAIL" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.email || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "Passport no" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.passportNo || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "ADDRESS" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.address || "N/A" }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ─── Complaint Details ─── -->
    <div class="vc-card">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('complaint')">
        <span class="material-icons vc-header-icon">assignment</span>
        <span class="vc-header-title">{{ "COMPLAINT_DETAILS" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['complaint']">expand_more</span>
      </div>
      <ng-container *ngIf="!collapsed['complaint']">
        <div class="vc-stats-row">
          <div class="vc-stat-item">
            <div class="vc-stat-label">{{ "SEGMENT" | translate }}</div>
            <div class="vc-stat-value">
              <span [ngSwitch]="complaint?.segmentId">
                <span *ngSwitchCase="1">PULSE</span>
                <span *ngSwitchCase="2">PLRA</span>
                <span *ngSwitchDefault>-</span>
              </span>
            </div>
          </div>
          <div class="vc-stat-item">
            <div class="vc-stat-label">{{ "PRIORITY" | translate }}</div>
            <div class="vc-stat-value" [class]="'vc-stat-value--' + (complaint?.priority | lowercase)">
              {{ complaint?.priority || "N/A" }}
            </div>
          </div>
          <div class="vc-stat-item">
            <div class="vc-stat-label">{{ "SEVERITY" | translate }}</div>
            <div class="vc-stat-value" [class]="'vc-stat-value--' + (complaint?.severity | lowercase)">
              {{ complaint?.severity || "N/A" }}
            </div>
          </div>
        </div>
        <div class="vc-card-body">
          <div class="vc-fields-grid">
            <!-- Row 2: Complainant Type, Complaint Type -->
            <div class="vc-field vc-field--half">
              <div class="vc-field-label">{{ "COMPLAINT_TYPE" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.complaintCategoryName || "N/A" }}</div>
            </div>
            <div class="vc-field vc-field--half">
              <div class="vc-field-label">{{ "COMPLAINT_SUBTYPE" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.complaintSubcategoryName || "N/A" }}</div>
            </div>
            <!-- Row 3: Legal Framework (2 cols), Days Required, Expected Resolution Date -->
            <div class="vc-field vc-field--half">
              <div class="vc-field-label">{{ "LEGAL_FRAMEWORK" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.legalFramework || "N/A" }}</div>
            </div>
            <div class="vc-field">
              <div class="vc-field-label">{{ "DAYS_REQUIRED" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.daysRequired || "N/A" }}</div>
            </div>
            <div class="vc-field">
              <div class="vc-field-label">{{ "EXPECTD_RESOLUTION_DATE" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.expectedResolutionDate ? (complaint?.expectedResolutionDate | date:'dd-MM-yyyy') : "N/A" }}</div>
            </div>
            <!-- Row 4: Division, District, Tehsil, Mouza -->
            <div class="vc-field">
              <div class="vc-field-label">{{ "DIVISION" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.divisionName || "N/A" }}</div>
            </div>
            <div class="vc-field">
              <div class="vc-field-label">{{ "DISTRICT" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.districtName || "N/A" }}</div>
            </div>
            <div class="vc-field">
              <div class="vc-field-label">{{ "TEHSIL" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.tehsilName || "N/A" }}</div>
            </div>
            <div class="vc-field">
              <div class="vc-field-label">{{ "MOUZA" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.mouzaName || "N/A" }}</div>
            </div>
            <!-- Row 5: Complaint Address -->
            <div class="vc-field vc-field--full">
              <div class="vc-field-label">{{ "COMPLAINT_ADDRESS" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.complaintAddress || "N/A" }}</div>
            </div>
            <!-- Row 6: Other Forum -->
            <div class="vc-field vc-field--full">
              <div class="vc-field-label">{{ "OTHER_FORUM" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.otherForum || "N/A" }}</div>
            </div>
            <!-- Row 7: Assign To, Assign To Group -->
            <div class="vc-field vc-field--half">
              <div class="vc-field-label">{{ "ASSIGN_TO" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.assignToName || "N/A" }}</div>
            </div>
            <div class="vc-field vc-field--half">
              <div class="vc-field-label">{{ "ASSIGN_TO_GROUP" | translate }}</div>
              <div class="vc-field-value">{{ complaint?.assignToGroupName || 'Not Assigned' }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ─── Description ─── -->
    <div class="vc-card">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('description')">
        <span class="material-icons vc-header-icon">description</span>
        <span class="vc-header-title">{{ "DESCRIPTION" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['description']">expand_more</span>
      </div>
      <div class="vc-card-body" *ngIf="!collapsed['description']">
        <div class="vc-description-box">
          <span class="vc-description-text" [innerHTML]="complaint?.complaintDetails || 'N/A'"></span>
        </div>
      </div>
    </div>

    <!-- ─── Additional Details ─── -->
    <div class="vc-card">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('additional')">
        <span class="material-icons vc-header-icon">info</span>
        <span class="vc-header-title">{{ "ADDITIONAL_DETAIL" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['additional']">expand_more</span>
      </div>
      <div class="vc-card-body" *ngIf="!collapsed['additional']">
        <div class="vc-additional-grid">
          <div class="vc-field">
            <div class="vc-field-label">{{ "WORK_CODE" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.workCode || 'N/A' }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "HELPLINE_IDENTIFIER" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.helplineIdentifier || "N/A" }}</div>
          </div>
          <div class="vc-field">
            <div class="vc-field-label">{{ "SOURCE" | translate }}</div>
            <div class="vc-field-value">{{ complaint?.complaintSource || "N/A" }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ─── Attachments ─── -->
    <div class="vc-card">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('attachments')">
        <span class="material-icons vc-header-icon">attach_file</span>
        <span class="vc-header-title">{{ "ATTACHMENTS" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['attachments']">expand_more</span>
      </div>
      <div class="vc-card-body" *ngIf="!collapsed['attachments']">
        <div class="vc-attachments-grid" *ngIf="documentList && documentList.length > 0">
          <div class="vc-attachment-card" *ngFor="let doc of documentList">
            <div class="vc-att-icon-wrap"
              [ngClass]="'vc-att-icon-wrap--' + (doc.documentType.includes('pdf') ? 'pdf' : 'image')">
              <span class="material-icons vc-att-icon">
                {{ doc.documentType.includes('pdf') ? 'picture_as_pdf' : 'image' }}
              </span>
            </div>
            <div class="vc-att-info">
              <span class="vc-att-name">{{ doc.documentName }}</span>
              <span class="vc-att-meta">{{ doc.documentType.toUpperCase() }}</span>
            </div>
            <button class="vc-att-view-btn" (click)="preview(doc.complaintDocumentId)" title="View">
              <span class="material-icons">visibility</span>
            </button>
          </div>
        </div>
        <div class="vc-empty-state" *ngIf="!documentList || documentList.length === 0">
          <span class="material-icons vc-empty-icon">insert_drive_file</span>
          <p class="vc-empty-text">No attachments found</p>
        </div>
      </div>
    </div>

    <!-- ─── Activity ─── -->
    <div class="vc-card vc-card--last">
      <div class="vc-card-header vc-card-header--clickable" (click)="toggleCard('activity')">
        <span class="material-icons vc-header-icon">history</span>
        <span class="vc-header-title">{{ "ACTIVITY" | translate }}</span>
        <span class="material-icons vc-chevron" [class.vc-chevron--collapsed]="collapsed['activity']">expand_more</span>
      </div>
      <div class="vc-card-body" *ngIf="!collapsed['activity']">
        <div class="vc-timeline" *ngIf="trackingList && trackingList.length > 0">
          <div class="vc-tl-entry" *ngFor="let item of trackingList; let last = last" [class.vc-tl-entry--last]="last">
            <!-- Dot + line -->
            <div class="vc-tl-rail">
              <span class="material-icons vc-tl-dot">arrow_upward</span>
              <div class="vc-tl-line" *ngIf="!last"></div>
            </div>
            <!-- Content -->
            <div class="vc-tl-content">
              <div class="vc-tl-header">
                <span class="vc-tl-who">{{ item.createdByName }}</span>
                <span class="vc-tl-when">{{ item.createdAt | date:'dd MMM yyyy, hh:mm a' }}</span>
              </div>
              <div class="vc-tl-body">
                <div class="vc-tl-row" *ngIf="item?.statusChangedName">
                  <span class="vc-tl-label">Status</span>
                  <span class="vc-tl-status-pill" [ngClass]="getStatusClass(item.statusChangedName)">
                    {{ item.statusChangedName }}
                  </span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.comment">
                  <span class="vc-tl-label">Comment</span>
                  <span class="vc-tl-text" [innerHTML]="item.comment"></span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.assignedToName">
                  <span class="vc-tl-label">Assigned To</span>
                  <span class="vc-tl-text">{{ item.assignedToName }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.assignedToGroupName">
                  <span class="vc-tl-label">Assigned Group</span>
                  <span class="vc-tl-text">{{ item.assignedToGroupName }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.priorityChanged">
                  <span class="vc-tl-label">Priority</span>
                  <span class="vc-tl-text">{{ item.priorityChanged }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.severityChanged">
                  <span class="vc-tl-label">Severity</span>
                  <span class="vc-tl-text">{{ item.severityChanged }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.documentName && item?.isRemove === null">
                  <span class="vc-tl-label">Attachment Added</span>
                  <span class="vc-tl-text">{{ item.documentName }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.documentName && item?.isRemove === true">
                  <span class="vc-tl-label">Attachment Removed</span>
                  <span class="vc-tl-text">{{ item.documentName }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.complaintEmailMessage">
                  <span class="vc-tl-label">Email</span>
                  <span class="vc-tl-text">{{ item.complaintEmailMessage }}</span>
                </div>
                <div class="vc-tl-row" *ngIf="item?.complaintSMSMessage">
                  <span class="vc-tl-label">SMS</span>
                  <span class="vc-tl-text">{{ item.complaintSMSMessage }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vc-empty-state" *ngIf="!trackingList || trackingList.length === 0">
          <span class="material-icons vc-empty-icon">history</span>
          <p class="vc-empty-text">No activity history found</p>
        </div>
      </div>
    </div>

  </div><!-- /.vc-card-group -->
</div>
}
